export default {
  REQUEST_FEATURE_AVAILABILITY: '@WS_EDITOR/REQUEST_FEATURE_AVAILABILITY',
};
